import { useState, useEffect } from 'react';
import { getCategoryTypes, CategoryType } from '../services/CategoryTypeService';

export const useCategoryTypes = () => {
  const [categoryTypes, setCategoryTypes] = useState<CategoryType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCategoryTypes = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const data = await getCategoryTypes();
        if (Array.isArray(data)) {
          setCategoryTypes(data);
        } else {
          setCategoryTypes([]);
        }
      } catch (err) {
        setError('Error al cargar los rubros');
        console.error('Error fetching category types:', err);
        setCategoryTypes([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCategoryTypes();
  }, []);

  return { categoryTypes, isLoading, error };
};
